import { styled as t } from "styled-components";
import { Colors as o } from "../../../../../styles/colors/index.js";
import { Avatar as r } from "../../../../../components/Avatar/index.js";
import { Body as e, Caption as a, CaptionHeavy as i } from "../../../../../styles/typography/index.js";
import { MediaQuery as n } from "../../../../../styles/variables.js";
import { Theme as p } from "../../../../../styles/themes/index.js";
const m = t.p`
  ${e}
  margin: 0;
  overflow: hidden;
  height: 52px;
  position: relative;
  color: rgb(${o.Gray});
  width: 100%;
  text-overflow: ellipsis;

  ${a}

  @media ${n.SCREEN_MD_UP} {
    height: 54px;
  }

  strong {
    margin-right: 3px;
    color: rgb(${p.colors.Alpha});
    ${i}
  }
`, f = t.button`
  display: flex;
  text-decoration: none;
  margin: unset;
  overflow: hidden;
  background: transparent;
  align-items: center;
  width: 100%;

  ${m} {
    height: auto;
    white-space: nowrap;
    text-align: left;

    &:after {
      top: 0;
    }
  }
`, x = t(r)`
  margin-right: 8px;
  flex-shrink: 0;

  &[data-size] {
    // !important added because styled-components break the order of classes and break on production
    width: 24px !important;
    height: 24px !important;
  }
`;
export {
  x as DealCardCommentAvatar,
  m as DealCardCommentParagraph,
  f as DealListCardComment
};
